import { DangerButton } from 'components/CustomButton'
import {isEmpty as isEmptyValue} from "lodash";
import React from "react";

const JobCardLoader = ({
  loading = false,
  count = 2,
  error = '',
  isEmpty = false,
  retry,
  keyName = '',
  height = '',
  paddingTop = '25.27'
}) => {
  const getShimmerByCount = () => {
    return Array.from({ length: count }, (_, i) => (
      <div key={`${keyName}-${i}`} className="animate-pulse">
        <div className={`bg-gray-200 w-full h-[178px] rounded-md mb-3 ${height}`}/>
      </div>
    ))
  }
  return error.length > 0 && !loading? (
    <div className="flex items-center justify-center">
      <div className="text-center space-y-4">
        <p className="text-red-500">{error ?? 'Error loading data.'}</p>
        <DangerButton onClick={retry}>Retry</DangerButton>
      </div>
    </div>
  ) : isEmpty && !loading ? (
    <div className="flex items-center justify-center text-secondary-200">
      No records to display
    </div>
  ) : (
    <div className="space-y-4">{getShimmerByCount()}</div>
  )
}

export default JobCardLoader
